import CustomizeQuickAccessBar from './CustomizeQuickAccessBar';
export default CustomizeQuickAccessBar;
